<template>
    <div class="inline-block relative" @mouseover.lazy="showLanguages = true" @mouseleave.lazy="showLanguages = false">
        <button type="button" class="cursor-pointer relative bg-transparent shadow-sm pl-3 pr-10 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm cursor-pointer">
            <span class="flex items-center">
                <img :src="'/images/langs/' + currentLang + '.png'" alt="" class="flex-shrink-0 h-3 w-3 rounded-full">
                <span class="ml-3 block truncate">
                    {{ $parent.__(currentLang) }}
                </span>
            </span>
            <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <svg class="h-2 w-2 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </span>
        </button>

        <ul id="language-options" :class="{ 'hidden': !showLanguages }" class="absolute z-10 bg-white shadow-lg max-h-56 rounded-xs py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm cursor-pointer" role="listbox">
            <li v-for="(item, key) in langues" class="hover:bg-gray-100 text-gray-900 cursor-default select-none relative">
                <inertia-link v-if="key !== currentLang" data-lang="en" :href="route('language-switcher', key)" class="cursor-pointer flex items-center w-full py-2 pl-3 pr-9" as="button">
                    <img :src="'/images/langs/' + key + '.png'" alt="" class="flex-shrink-0 h-3 w-3 rounded-full">
                    <span class="font-normal ml-3 block">
                        {{ $parent.__(key) }}
                    </span>
                </inertia-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    name: "LanguageSelector",

    data() {
        if(usePage().props.value.metas) {
            return {
                showLanguages: false,
                currentLang: computed(() => usePage().props.value.metas.locale),
                langues: computed(() => usePage().props.value.metas.langs)
            }
        } else {
            return {
                showLanguages: false,
                currentLang: computed(() => 'fr'),
                langues: computed(() => [])
            }
        }
    },
    methods: {
        //
    },
    mounted() {
        //
    }
}
</script>

<style scoped>

</style>
